"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var IconDeactivate = function IconDeactivate(_ref) {
  var style = _ref.style,
      className = _ref.className;
  return _react.default.createElement("svg", {
    width: "16px",
    height: "16px",
    className: (0, _classnames.default)('Icon', 'IconDeactivate', className),
    style: style,
    viewBox: "0 0 18 10"
  }, _react.default.createElement("g", {
    id: "Page-1",
    stroke: "none",
    "stroke-width": "1",
    fill: "none",
    "fill-rule": "evenodd"
  }, _react.default.createElement("g", {
    id: "New-Tags-in-Assignments-(Auto-assigned,-deactivating-in)",
    transform: "translate(-702.000000, -935.000000)",
    "fill-rule": "nonzero"
  }, _react.default.createElement("g", {
    id: "Group-4-Copy-3",
    transform: "translate(698.000000, 928.000000)"
  }, _react.default.createElement("g", {
    id: "Group-2",
    transform: "translate(5.000000, 8.000000)"
  }, _react.default.createElement("rect", {
    id: "Rectangle",
    stroke: "currentColor",
    "stroke-width": "1.3",
    x: "0",
    y: "0",
    width: "16",
    height: "8",
    rx: "4"
  }), _react.default.createElement("g", {
    id: "Group",
    transform: "translate(11.500000, 3.968750) rotate(45.000000) translate(-11.500000, -3.968750) translate(9.000000, 1.468750)",
    fill: "currentColor"
  }, _react.default.createElement("path", {
    d: "M4.4375,2.03125 C4.71364237,2.03125 4.9375,2.25510763 4.9375,2.53125 C4.9375,2.77670989 4.76062484,2.98085837 4.52737563,3.02319433 L4.4375,3.03125 L0.5,3.03125 C0.223857625,3.03125 0,2.80739237 0,2.53125 C0,2.28579011 0.176875161,2.08164163 0.410124368,2.03930567 L0.5,2.03125 L4.4375,2.03125 Z",
    id: "Line"
  }), _react.default.createElement("path", {
    d: "M4.46875,2 C4.74489237,2 4.96875,2.22385763 4.96875,2.5 C4.96875,2.74545989 4.79187484,2.94960837 4.55862563,2.99194433 L4.46875,3 L0.53125,3 C0.255107625,3 0.03125,2.77614237 0.03125,2.5 C0.03125,2.25454011 0.208125161,2.05039163 0.441374368,2.00805567 L0.53125,2 L4.46875,2 Z",
    id: "Line-Copy",
    transform: "translate(2.500000, 2.500000) rotate(90.000000) translate(-2.500000, -2.500000) "
  })), _react.default.createElement("rect", {
    id: "Rectangle-Copy",
    stroke: "currentColor",
    "stroke-width": "1.3",
    x: "0",
    y: "0.5",
    width: "7",
    height: "7",
    rx: "3.5"
  }))))));
};

var _default = IconDeactivate;
exports.default = _default;